module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.c45f7de0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Pe-icon-7-stroke.svg?d7yf1v
// module id = 2671
// module chunks = 33